module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_completed-2d08528cb712f57140f08bae2f75d729.png";